import useServicePriceTotal from '@/hooks/useServicePriceTotal'
import {
    Contract,
    ProductConfigOption,
    ServiceConfigOption,
} from '@/modules/Contract/types'
import { useEffect } from 'react'
import {
    ArrayPath,
    Path,
    useFieldArray,
    useFormContext,
    useWatch,
} from 'react-hook-form'
import Component from '../../../Config'

interface ConfigurationProps {
    product_config_options: ProductConfigOption[]
    index: number
    isPOC?: boolean
}

const Configuration: React.FC<ConfigurationProps> = ({
    product_config_options,
    index,
    isPOC = false,
}) => {
    const { setValue, control } = useFormContext<Contract>()
    const key = `order.products.[${index}].service_configoptions`

    const { fields, remove } = useFieldArray({
        control,
        name: key as ArrayPath<Contract>,
    })

    const service_configoptions = useWatch({
        control,
        name: key as Path<Contract>,
    }) as ServiceConfigOption[]

    const product_form = useWatch({
        control,
        name: `order.products.[${index}].product_form` as Path<Contract>,
    })

    useServicePriceTotal({
        control,
        index,
        service_configoptions,
        setValue,
    })

    useEffect(() => {
        const options = (product_config_options || [])?.map((option) => {
            return {
                name: option.name,
                unit: option.unit,
                type: option.type,
                prices:
                    option.product_pricing_steps?.length >= 0
                        ? option.product_pricing_steps?.map(
                              // eslint-disable-next-line @typescript-eslint/no-unused-vars
                              ({ product_pricing_step_id, ...rest }) => ({
                                  ...rest,
                              })
                          )
                        : [
                              {
                                  price_start: 0,
                                  price_end: 999999999,
                                  price_per_unit: 0,
                              },
                          ],
                price_config: {
                    method: 'progressive',
                },
                commitment_prepaid: isPOC ? false : true,
                statementable: isPOC ? false : true,
                commitment_value: product_form === 'commit' ? 1000 : undefined,
                commitment_price_per_unit:
                    product_form === 'commit' ? 0 : undefined,
                commitment_time: product_form === 'commit' ? 1 : undefined,
            }
        })

        setValue(key as Path<Contract>, options)
    }, [product_config_options, product_form])

    return (
        <div className="w-full">
            <div className="w-full">
                {fields?.map((option, i) => {
                    // @ts-ignore
                    const Comp = Component[option.type]
                    if (!Comp) return null

                    return (
                        <Comp
                            key={option.id}
                            index={i}
                            name={key}
                            productIndex={index}
                            remove={remove}
                            isPOC={isPOC}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default Configuration
